module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781429988476_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("D")]), _vm._v("eepest thanks to my editor, Stacy Hague-Hill, who saw potential in my jumble of a book and knew what it needed: You rock! And to agent extraordinaire Marlene Stringer, for faith, tenacity, and endless patience: You rock, too.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("To Dianne, my alpha reader, who keeps me real; to Debbie, my staunch advocate, who keeps me sane; to Larry, without whose encouragement DJ would never have seen daylight; to Susan, creator of mojo bags and one fine writer; to Mom, whose willingness to take on the “varmints” allowed me time to write; and to all those who read this in various stages of disarray and still speak to me: Nancy, Stella, Lauri, Amanda, Jennifer, Delaine, Pete, Matt K., Shawn, Matt L., and Meg.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Any mistakes in this book are mine, especially regarding the legendary people and places with whom I took great liberties.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9c095ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429988476_ack01.vue
// module id = 69
// module chunks = 0